import spash_background from "../assets/splash_background.jpg";

export const backgroundStyles: React.CSSProperties = {
  backgroundImage: `url(${spash_background})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "cover",
};
